/* eslint-disable no-useless-catch */
import axios from 'axios';

export async function addressValidation(address) {
  const requestBody = {
    query: `
    query {
        addressValidation(address: "${address}")
    }
    `,
    queryName: 'address_validation',
  };
  const response = await axios.post('/api', requestBody);
  return response.data.data;
}
